{
  "name": "art-admin",
  "version": "1.0.8",
  "apiVersion": "1.0.5",
  "scripts": {
    "ng": "ng",
    "start": "ng serve",
    "start-gitpod": "ng serve --disable-host-check --configuration=dev",
    "build": "ng build --configuration=dev",
    "build-dev": "ng build --configuration=dev",
    "build-uat": "ng build --configuration=uat",
    "build-prod": "ng build --configuration production",
    "watch": "ng build --watch --configuration development",
    "download-pdf-fonts": "node scripts/download-pdf-fonts.mjs"
  },
  "private": true,
  "dependencies": {
    "@angular/animations": "^21.0.6",
    "@angular/cdk": "^21.0.5",
    "@angular/common": "^21.0.6",
    "@angular/compiler": "^21.0.6",
    "@angular/core": "^21.0.6",
    "@angular/forms": "^21.0.6",
    "@angular/material": "^21.0.5",
    "@angular/platform-browser": "^21.0.6",
    "@angular/platform-browser-dynamic": "^21.0.6",
    "@angular/router": "^21.0.6",
    "@devlukaszmichalak/mat-select-filter": "^21.0.0",
    "@fortawesome/free-solid-svg-icons": "^7.2.0",
    "@material-design-icons/svg": "^0.11.1",
    "@ngneat/until-destroy": "~9.2.0",
    "@ngrx/component": "^21.0.1",
    "@ngx-loading-bar/core": "^6.0.2",
    "@ngx-loading-bar/router": "^6.0.2",
    "@tinymce/tinymce-angular": "^7.0.0",
    "angular-calendar": "~0.29.0",
    "apexcharts": "~3.35.3",
    "buffer": "^6.0.3",
    "date-fns": "~2.28.0",
    "exceljs": "^4.4.0",
    "flag-icons": "^7.2.3",
    "highlight.js": "~11.5.1",
    "jspdf": "^4.2.1",
    "jspdf-autotable": "^5.0.7",
    "luxon": "~2.3.0",
    "ngx-chips": "^3.0.0",
    "ngx-dropzone": "^3.1.0",
    "ngx-quicklink": "^0.4.9",
    "ngx-quill": "~17.0.0",
    "ngx-showdown": "^6.0.0",
    "quill": "~1.3.7",
    "rxjs": "^7.8.2",
    "showdown": "^1.9.1",
    "simplebar": "~5.3.8",
    "tailwindcss": "^3.0.24",
    "tslib": "^2.4.1",
    "xlsx": "^0.18.5",
    "zone.js": "~0.15.1"
  },
  "devDependencies": {
    "@angular-devkit/build-angular": "^21.0.4",
    "@angular/cli": "^21.0.4",
    "@angular/compiler-cli": "^21.0.6",
    "@angular/language-service": "^21.0.6",
    "@faker-js/faker": "^7.1.0",
    "@types/jest": "^30.0.0",
    "@types/luxon": "^2.3.2",
    "@types/node": "^22.19.3",
    "@types/showdown": "~1.9.4",
    "autoprefixer": "^10.4.0",
    "ng-openapi-gen": "^0.23.0",
    "postcss": "~8.4.14",
    "postcss-scss": "~4.0.4",
    "ts-node": "^10.9.2",
    "typescript": "~5.9.3"
  }
}
